// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2663":"6b9bcf9b","7660":"8b1cb96d","7953":"c9157020","8615":"243a0a9c","8688":"6a7ad95e","8892":"385f5713"}[chunkId] + ".chunk.css";
};